<template>
  <div class="interactive-video-player-layout">
    <div class="video-side">
      <videojs-markers-player v-if="videoUrl" :video-url="videoUrl">
        <div class="questions-side">
          <interactive-questions-list />
        </div>
      </videojs-markers-player>
    </div>
    <component :is="getModalComponent(selectedMarkerType)" v-if="showModal" />
  </div>
</template>

<script>
import VideojsMarkersPlayer from "@/view/components/video/interactive-video/VideojsMarkersPlayer.vue";
import InteractiveQuestionsList from "@/view/components/video/interactive-video/InteractiveQuestionsList.vue";
import MultiChoiceQuestionModal from './question-modals/MultiChoiceQuestionModal.vue';
import MultiSectionQuestionModal from './question-modals/MultiSectionQuestionModal.vue';

export default {
  name: "InteractiveVideoPlayer",
  components: {
    VideojsMarkersPlayer,
    InteractiveQuestionsList,
    MultiChoiceQuestionModal,
    MultiSectionQuestionModal
  },
  props: {
    videoUrl: {
      type: String,
      required: true
    },
  },
  computed: {
    markers() {
      return this.$store.getters.markers;
    },
    markerTypes() {
      return this.$store.getters.markerTypes;
    },
    showModal() {
      return this.$store.getters.showModal;
    },
    selectedMarkerType() {
      return this.$store.getters.selectedMarkerType;
    },
    selectedItemData() {
      return this.$store.getters.selectedItemData;
    }
  },
  methods: {
    getModalComponent(markerType) {
      if (!markerType) return null;
      switch (markerType.typeId) {
        case 1:
          return 'MultiChoiceQuestionModal';
        case 2:
          return 'MultiSectionQuestionModal';
        default:
          return 'MultiChoiceQuestionModal';
      }
    }
  }
}
</script>

<style scoped>
.interactive-video-player-layout {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 32px;
}

.video-side {
  flex: 2 1 0;
  min-width: 0;
}

.questions-side {
  flex: 1 1 320px;
  min-width: 320px;
  max-width: 400px;
}
</style>